 export const Collection = {
    LOADING_COLLECTION_LIST: "LOADING_COLLECTION_LIST",
    GET_COLLECTION_LIST: "GET_COLLECTION_LIST",
  };